import * as React from 'react';
/**
 *
 * Original name: warning
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=13904%3A2615
 *
 */
export const WarningSpot = (props) => (React.createElement("svg", { viewBox: "0 0 120 120", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 107h102L60 13 9 107Zm10.081-6h81.837L60 25.582 19.081 101Z", fill: "currentColor" }),
    React.createElement("path", { d: "M60 83.009A2.778 2.778 0 0 0 57.009 86 2.777 2.777 0 0 0 60 88.991 2.778 2.778 0 0 0 62.991 86 2.778 2.778 0 0 0 60 83.009ZM63 80V57h-6v23c1.965-.54 4.035-.54 6 0Z", fill: "currentColor" })));
